/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component } from '@angular/core';

@Component({
  selector: 'sysque-no-access',
  templateUrl: './no-access.html',
  styleUrls: ['./no-access.scss'],
  standalone: false
})
export class NoAccessComponent {}
